import RelatedContent from 'components/related-content/RelatedContent';
import SearchResult from 'components/search-result/SearchResult';

import { IRelatedPublications } from 'source/NFR.types';

const RelatedPublications: React.FC<IRelatedPublications> = ({
  relatedContent,
  publications,
  usedInSidebar = false
}) => (
  <RelatedContent {...relatedContent}>
    {publications?.map(publication => (
      <SearchResult
        headingLevel={3}
        key={publication.title}
        theme={usedInSidebar ? 'sidebar' : 'noBorder'}
        {...publication}
        isLink
      />
    ))}
  </RelatedContent>
);

RelatedPublications.displayName = 'RelatedPublications';

export default RelatedPublications;
